__turbopack_context__.v({
  "givebutton": "QOmp8G_givebutton",
  "givebuttoninverted": "QOmp8G_givebuttoninverted",
});
